// AddItemForm.jsx
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import ItemForm from "../ItemForm";
import { fetchSectionsData } from "../../../../redux/actions/careplanActions";

const AddItemForm = React.forwardRef(({ onSave, onCancel, formError }, ref) => {
  const dispatch = useDispatch();
  const { sections, sectionsLoaded } = useSelector((s) => s.careplan);

  useEffect(() => {
    if (!sectionsLoaded) dispatch(fetchSectionsData());
  }, [sectionsLoaded, dispatch]);

  // 1️⃣ Memoize initialValues once
  const initialValues = useMemo(
    () => ({
      title: "",
      description: "",
      image: null,
      image_url: null,
      image_alt_text: "",
      prompt_text: "",
      standard_answers: [],
      resource_link: "",
      qr_code: "",
      hide_from_service_user_specific: false,
      usePrompt: true,
      section_answers: {}, // blank map
      section_prompts: {},
    }),
    []
  );

  const handleSave = (newItem) => {
    onSave(newItem);
  };

  return (
    <ItemForm
      ref={ref}
      initialValues={initialValues}
      sections={sections}
      initialSectionAnswers={initialValues.section_answers} // 2️⃣ explicit
      initialSectionPrompts={initialValues.section_prompts}
      onSubmit={handleSave}
      onCancel={onCancel}
      formError={formError}
    />
  );
});

export default AddItemForm;
